// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inherits task mode's --pt-* palette when rendered inside it; falls back to site colours elsewhere. */
:host([hidden]) {
  display: none !important;
}

:host {
  --gq-brand: var(--pt-brand, var(--fc-brand, #5ea1d8));
  --gq-surface: var(--pt-surface, #ffffff);
  --gq-text: var(--pt-text, #333333);
  --gq-muted: var(--pt-muted, #666666);
  --gq-border: var(--pt-border, #e0e0e0);
  --gq-soft: var(--pt-bg, #f3f4f6);
  display: block;
  font-family: "Raleway", sans-serif;
  color: var(--gq-text);
}

:host-context(body.theme-dark) {
  --gq-surface: var(--pt-surface, #111827);
  --gq-text: var(--pt-text, #e2e8f0);
  --gq-muted: var(--pt-muted, #94a3b8);
  --gq-border: var(--pt-border, rgba(148, 163, 184, 0.3));
  --gq-soft: var(--pt-bg, #1f2937);
}

.gqf {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gqf__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.gqf__title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--gq-text);
}

.gqf__sub {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--gq-muted);
}

.gqf__req {
  color: #d32f2f;
}

.gqf__close {
  color: var(--gq-muted) !important;
  flex: 0 0 auto;
  margin: -8px -8px 0 0;
}

.gqf__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gqf__q {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.gqf__q-text {
  padding: 0;
  margin: 0 0 10px;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--gq-text);
}

.gqf__options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Same look as task mode's checklist rows. */
.gqf__option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 12px 16px;
  box-sizing: border-box;
  border: 1px solid var(--gq-border);
  border-radius: 12px;
  background: var(--gq-surface);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.gqf__option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.gqf__option:hover {
  border-color: var(--gq-brand);
}
.gqf__option:focus-within {
  outline: 2px solid var(--gq-brand);
  outline-offset: 2px;
}
.gqf__option--on {
  border-color: var(--gq-brand);
  background: rgba(94, 161, 216, 0.1);
}

.gqf__mark {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  border: 2px solid var(--gq-border);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.gqf__mark--box {
  border-radius: 6px;
}
.gqf__mark mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #ffffff;
  opacity: 0;
}
.gqf__option--on .gqf__mark {
  background: var(--gq-brand);
  border-color: var(--gq-brand);
}
.gqf__option--on .gqf__mark mat-icon {
  opacity: 1;
}

.gqf__option-text {
  font-size: 1rem;
  line-height: 1.4;
}

.gqf__hint {
  margin: 0;
  font-size: 13px;
  color: var(--gq-muted);
}

.gqf__textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid var(--gq-border);
  border-radius: 12px;
  background: var(--gq-surface);
  color: var(--gq-text);
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.5;
  resize: vertical;
}
.gqf__textarea:focus {
  outline: none;
  border-color: var(--gq-brand);
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}

.gqf__number {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.gqf__number-field {
  display: flex;
  align-items: stretch;
  max-width: 320px;
  border: 1px solid var(--gq-border);
  border-radius: 12px;
  background: var(--gq-surface);
  overflow: hidden;
}
.gqf__number-field:focus-within {
  border-color: var(--gq-brand);
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}

.gqf__number-input {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 52px;
  padding: 0 14px;
  border: 0;
  background: transparent;
  color: var(--gq-text);
  font-family: inherit;
  font-size: 1rem;
}
.gqf__number-input:focus {
  outline: none;
}

.gqf__unit {
  display: inline-flex;
  align-items: center;
  padding: 0 14px;
  border-left: 1px solid var(--gq-border);
  background: var(--gq-soft);
  color: var(--gq-muted);
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
}

.gqf__photo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gqf__upload {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 72px;
  padding: 12px 16px;
  border: 1.5px dashed var(--gq-border);
  border-radius: 12px;
  background: var(--gq-soft);
  color: var(--gq-brand);
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.gqf__upload input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
.gqf__upload mat-icon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}
.gqf__upload:hover, .gqf__upload:focus-within {
  border-color: var(--gq-brand);
}
.gqf__upload--busy {
  pointer-events: none;
  opacity: 0.8;
}

.gqf__photo-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.gqf__photo-preview img {
  display: block;
  max-width: 100%;
  max-height: 280px;
  border-radius: 10px;
  border: 1px solid var(--gq-border);
  object-fit: contain;
}

.gqf__photo-remove {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid var(--gq-border);
  border-radius: 10px;
  background: transparent;
  color: var(--gq-text);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
}
.gqf__photo-remove mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}

.gqf__field-error {
  margin: 8px 0 0;
  color: #b45309;
  font-size: 0.92rem;
}

.gqf__error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #ffebee;
  color: #b71c1c;
  font-size: 14px;
}
.gqf__error mat-icon {
  flex: 0 0 auto;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.gqf__link {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.gqf__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.gqf__spacer {
  flex: 1 1 auto;
}

/* Matches the primary / secondary buttons in the site's dialogs. */
.gqf__btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease;
}
.gqf__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gqf__btn--primary {
  background: var(--gq-brand);
  color: #ffffff;
}
.gqf__btn--primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.gqf__btn--secondary {
  background: var(--gq-soft);
  color: var(--gq-text);
  border: 1px solid var(--gq-border);
}
.gqf__btn--secondary:hover:not(:disabled) {
  filter: brightness(0.97);
}

/* Inline (task mode): same size as the task mode action bar buttons. */
.gqf:not(.gqf--dialog) .gqf__btn {
  min-height: 52px;
  padding: 0 20px;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 600;
}
.gqf:not(.gqf--dialog) .gqf__btn--primary {
  flex: 1 1 auto;
}

:host-context(body.theme-dark) .gqf__error {
  background: rgba(127, 29, 29, 0.35);
  color: #fecaca;
}

/* Dialog layout: header / scrolling body / footer bar, like the completion dialog. */
.gqf--dialog {
  gap: 0;
  max-height: 85vh;
}
.gqf--dialog .gqf__head {
  padding: 20px 24px;
  border-bottom: 1px solid var(--gq-border);
}
.gqf--dialog .gqf__title {
  font-size: 22px;
  font-weight: 500;
}
.gqf--dialog .gqf__close {
  margin: -6px -10px 0 0;
}
.gqf--dialog .gqf__body {
  padding: 24px;
  overflow-y: auto;
}
.gqf--dialog .gqf__actions {
  padding: 20px 24px;
  border-top: 1px solid var(--gq-border);
}

@media (max-width: 640px) {
  .gqf--dialog .gqf__head,
  .gqf--dialog .gqf__body,
  .gqf--dialog .gqf__actions {
    padding-left: 16px;
    padding-right: 16px;
  }
  .gqf__btn {
    flex: 1 1 auto;
  }
  .gqf__spacer {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/guide-questions/guide-question-form.component.scss"],"names":[],"mappings":"AAAA,uGAAA;AACA;EACE,wBAAA;AACF;;AAEA;EACE,qDAAA;EACA,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,gCAAA;EACA,cAAA;EACA,kCAAA;EACA,qBAAA;AACF;;AAEA;EACE,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,uDAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,iCAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA,6CAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,0DAAA;AACF;AACE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AACJ;AAEE;EACE,6BAAA;AAAJ;AAGE;EACE,kCAAA;EACA,mBAAA;AADJ;AAIE;EACE,6BAAA;EACA,mCAAA;AAFJ;;AAMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,0DAAA;AAHF;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAJJ;AAOE;EACE,2BAAA;EACA,6BAAA;AALJ;AAOI;EACE,UAAA;AALN;;AAUA;EACE,eAAA;EACA,gBAAA;AAPF;;AAUA;EACE,SAAA;EACA,eAAA;EACA,sBAAA;AAPF;;AAUA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAPF;AASE;EACE,aAAA;EACA,6BAAA;EACA,6CAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARF;;AAWA;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AARF;AAUE;EACE,6BAAA;EACA,6CAAA;AARJ;;AAYA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AATF;AAWE;EACE,aAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVF;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AAVF;AAYE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAVJ;AAaE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAXJ;AAcE;EAEE,6BAAA;AAbJ;AAgBE;EACE,oBAAA;EACA,YAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAfF;AAiBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;AAfJ;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAjBF;AAmBE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACE,iBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA,mEAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AAlBF;AAoBE;EACE,YAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,2BAAA;EACA,cAAA;AAnBJ;AAqBI;EACE,mBAAA;AAnBN;AAuBE;EACE,0BAAA;EACA,qBAAA;EACA,kCAAA;AArBJ;AAuBI;EACE,wBAAA;AArBN;;AA0BA,uEAAA;AACA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,cAAA;AAvBJ;;AA2BA;EACE,mCAAA;EACA,cAAA;AAxBF;;AA2BA,qFAAA;AACA;EACE,MAAA;EACA,gBAAA;AAxBF;AA0BE;EACE,kBAAA;EACA,yCAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,sBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,sCAAA;AA5BJ;;AAgCA;EAEI;;;IAGE,kBAAA;IACA,mBAAA;EA9BJ;EAkCA;IACE,cAAA;EAhCF;EAmCA;IACE,aAAA;EAjCF;AACF","sourcesContent":["/* Inherits task mode's --pt-* palette when rendered inside it; falls back to site colours elsewhere. */\n:host([hidden]) {\n  display: none !important;\n}\n\n:host {\n  --gq-brand: var(--pt-brand, var(--fc-brand, #5ea1d8));\n  --gq-surface: var(--pt-surface, #ffffff);\n  --gq-text: var(--pt-text, #333333);\n  --gq-muted: var(--pt-muted, #666666);\n  --gq-border: var(--pt-border, #e0e0e0);\n  --gq-soft: var(--pt-bg, #f3f4f6);\n  display: block;\n  font-family: \"Raleway\", sans-serif;\n  color: var(--gq-text);\n}\n\n:host-context(body.theme-dark) {\n  --gq-surface: var(--pt-surface, #111827);\n  --gq-text: var(--pt-text, #e2e8f0);\n  --gq-muted: var(--pt-muted, #94a3b8);\n  --gq-border: var(--pt-border, rgba(148, 163, 184, 0.3));\n  --gq-soft: var(--pt-bg, #1f2937);\n}\n\n.gqf {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.gqf__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.gqf__title {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--gq-text);\n}\n\n.gqf__sub {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: var(--gq-muted);\n}\n\n.gqf__req {\n  color: #d32f2f;\n}\n\n.gqf__close {\n  color: var(--gq-muted) !important;\n  flex: 0 0 auto;\n  margin: -8px -8px 0 0;\n}\n\n.gqf__body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.gqf__q {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.gqf__q-text {\n  padding: 0;\n  margin: 0 0 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--gq-text);\n}\n\n.gqf__options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Same look as task mode's checklist rows. */\n.gqf__option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 52px;\n  padding: 12px 16px;\n  box-sizing: border-box;\n  border: 1px solid var(--gq-border);\n  border-radius: 12px;\n  background: var(--gq-surface);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &:hover {\n    border-color: var(--gq-brand);\n  }\n\n  &:focus-within {\n    outline: 2px solid var(--gq-brand);\n    outline-offset: 2px;\n  }\n\n  &--on {\n    border-color: var(--gq-brand);\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.gqf__mark {\n  flex: 0 0 auto;\n  width: 22px;\n  height: 22px;\n  border: 2px solid var(--gq-border);\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &--box {\n    border-radius: 6px;\n  }\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    color: #ffffff;\n    opacity: 0;\n  }\n\n  .gqf__option--on & {\n    background: var(--gq-brand);\n    border-color: var(--gq-brand);\n\n    mat-icon {\n      opacity: 1;\n    }\n  }\n}\n\n.gqf__option-text {\n  font-size: 1rem;\n  line-height: 1.4;\n}\n\n.gqf__hint {\n  margin: 0;\n  font-size: 13px;\n  color: var(--gq-muted);\n}\n\n.gqf__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid var(--gq-border);\n  border-radius: 12px;\n  background: var(--gq-surface);\n  color: var(--gq-text);\n  font-family: inherit;\n  font-size: 1rem;\n  line-height: 1.5;\n  resize: vertical;\n\n  &:focus {\n    outline: none;\n    border-color: var(--gq-brand);\n    box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n  }\n}\n\n.gqf__number {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.gqf__number-field {\n  display: flex;\n  align-items: stretch;\n  max-width: 320px;\n  border: 1px solid var(--gq-border);\n  border-radius: 12px;\n  background: var(--gq-surface);\n  overflow: hidden;\n\n  &:focus-within {\n    border-color: var(--gq-brand);\n    box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n  }\n}\n\n.gqf__number-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 52px;\n  padding: 0 14px;\n  border: 0;\n  background: transparent;\n  color: var(--gq-text);\n  font-family: inherit;\n  font-size: 1rem;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.gqf__unit {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 14px;\n  border-left: 1px solid var(--gq-border);\n  background: var(--gq-soft);\n  color: var(--gq-muted);\n  font-size: 0.95rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.gqf__photo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.gqf__upload {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 72px;\n  padding: 12px 16px;\n  border: 1.5px dashed var(--gq-border);\n  border-radius: 12px;\n  background: var(--gq-soft);\n  color: var(--gq-brand);\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  input {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  mat-icon {\n    flex: 0 0 auto;\n    width: 24px;\n    height: 24px;\n    font-size: 24px;\n    line-height: 24px;\n  }\n\n  &:hover,\n  &:focus-within {\n    border-color: var(--gq-brand);\n  }\n\n  &--busy {\n    pointer-events: none;\n    opacity: 0.8;\n  }\n}\n\n.gqf__photo-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n\n  img {\n    display: block;\n    max-width: 100%;\n    max-height: 280px;\n    border-radius: 10px;\n    border: 1px solid var(--gq-border);\n    object-fit: contain;\n  }\n}\n\n.gqf__photo-remove {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--gq-border);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--gq-text);\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n\n  mat-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    line-height: 18px;\n  }\n}\n\n.gqf__field-error {\n  margin: 8px 0 0;\n  color: #b45309;\n  font-size: 0.92rem;\n}\n\n.gqf__error {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  background: #ffebee;\n  color: #b71c1c;\n  font-size: 14px;\n\n  mat-icon {\n    flex: 0 0 auto;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n}\n\n.gqf__link {\n  margin-left: auto;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.gqf__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.gqf__spacer {\n  flex: 1 1 auto;\n}\n\n/* Matches the primary / secondary buttons in the site's dialogs. */\n.gqf__btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-family: \"Raleway\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease, opacity 0.2s ease;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &--primary {\n    background: var(--gq-brand);\n    color: #ffffff;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n    }\n  }\n\n  &--secondary {\n    background: var(--gq-soft);\n    color: var(--gq-text);\n    border: 1px solid var(--gq-border);\n\n    &:hover:not(:disabled) {\n      filter: brightness(0.97);\n    }\n  }\n}\n\n/* Inline (task mode): same size as the task mode action bar buttons. */\n.gqf:not(.gqf--dialog) .gqf__btn {\n  min-height: 52px;\n  padding: 0 20px;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 600;\n\n  &--primary {\n    flex: 1 1 auto;\n  }\n}\n\n:host-context(body.theme-dark) .gqf__error {\n  background: rgba(127, 29, 29, 0.35);\n  color: #fecaca;\n}\n\n/* Dialog layout: header / scrolling body / footer bar, like the completion dialog. */\n.gqf--dialog {\n  gap: 0;\n  max-height: 85vh;\n\n  .gqf__head {\n    padding: 20px 24px;\n    border-bottom: 1px solid var(--gq-border);\n  }\n\n  .gqf__title {\n    font-size: 22px;\n    font-weight: 500;\n  }\n\n  .gqf__close {\n    margin: -6px -10px 0 0;\n  }\n\n  .gqf__body {\n    padding: 24px;\n    overflow-y: auto;\n  }\n\n  .gqf__actions {\n    padding: 20px 24px;\n    border-top: 1px solid var(--gq-border);\n  }\n}\n\n@media (max-width: 640px) {\n  .gqf--dialog {\n    .gqf__head,\n    .gqf__body,\n    .gqf__actions {\n      padding-left: 16px;\n      padding-right: 16px;\n    }\n  }\n\n  .gqf__btn {\n    flex: 1 1 auto;\n  }\n\n  .gqf__spacer {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
